import { useCallback, useState } from 'react';
import { loadPrefs, savePrefs } from '../utils/browseUtils';

export function useBrowsePrefs() {
  const [prefs, setPrefs] = useState(loadPrefs);

  const setPref = useCallback((patch) => {
    setPrefs((prev) => {
      const next = { ...prev, ...patch };
      savePrefs(next);
      return next;
    });
  }, []);

  const toggleSort = useCallback(
    (id) => {
      if (prefs.sort === id) setPref({ dir: prefs.dir === 'asc' ? 'desc' : 'asc' });
      else setPref({ sort: id, dir: id === 'date' || id === 'count' ? 'desc' : 'asc' });
    },
    [prefs.sort, prefs.dir, setPref]
  );

  return { prefs, setPref, toggleSort };
}
